import styled from "styled-components";

export const ActivityLogContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0px 48px;

    .active-filter-count {
        border: 1px solid #FFFFFF;
        border-radius: 4px;
        padding: 8px 8px;
        display: flex;
        gap: 8px;

        h3 {
            color: #FFFFFF;
            font-size: 10px;
            font-weight: 500;
        }

        h4 {
            color: #FFFFFF;
            font-size: 10px;
            font-weight: 500;
        }
    }
`

export const FilterContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    margin-top: 8px;
`
export const ActivityLogDisplay = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 48px;
    width: 100%;

    h3 {
        color: #FFFFFF;
        font-size: 10px;
        font-weight: 500;
    }

    p {
        font-weight: 600;
        margin-top: 24px;
        text-align: center;
    }
`